'use strict';

var base = require('org/components/quantityInput');

/**
 * @desc gets the max input value
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @returns {int} the max value
 */
function getQtyMaxValue(qtyInput) {
    return parseInt(qtyInput.attr('max'), 0);
}

/**
 * @desc gets the min input value
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @returns {int} the min value
 */
function getQtyMinValue(qtyInput) {
    return parseInt(qtyInput.attr('min'), 0);
}

/**
 * @desc warns user if desired quantity is close to product inventory
 * @param {string} pid - product id
 * @param {string} url - url of request
 * @param {int} updatedValue - qty value
 */
function warnNearInventoryLimit(pid, url, updatedValue) {
    $.ajax({
        url: url,
        method: 'GET',
        data: {
            pid: pid,
            qty: updatedValue
        },
        dataType: 'json',
        success: (data) => {
            if (data.outsideInventory) {
                $('body').append('<div class="alert alert-warning qty-alert" role="alert">' + data.msg + '</div>');
                setTimeout(function () {
                    $('.qty-alert').remove();
                }, 5000);
            }
        }
    });
}

/**
 * @desc quantity increase
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @param {string} pid - product id
 */
function qtyIncrease(qtyInput, pid) {
    var qtyMax = getQtyMaxValue(qtyInput);
    var updatedValue = parseInt(qtyInput.val(), 10) + 1;
    if (updatedValue <= qtyMax) {
        qtyInput.val(updatedValue);
        var url = qtyInput.parents('.quantity-form').data('action-url');
        if (url !== '') {
            warnNearInventoryLimit(pid, url, updatedValue);
        }
    }
}

/**
 * @desc quantity decrease
 * @param {jqueryObject} qtyInput - jquery selector of input field
 */
function qtyDecrease(qtyInput) {
    var qtyMin = getQtyMinValue(qtyInput);
    var updatedValue = parseInt(qtyInput.val(), 10) - 1;
    if (updatedValue >= qtyMin) {
        qtyInput.val(updatedValue);
    }
}

var exportQuantityInput = $.extend({}, base, {
    wishlistInit: function () {
        var $qtyInput = $('.wishlist-product-info .quantity-form input[type="text"]');

        $('body').on('click', '.wishlist-product-info .quantity-form .plus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyIncrease($qtyInput);
        });

        $('body').on('click', '.wishlist-product-info .quantity-form .minus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyDecrease($qtyInput);
        });
    },

    bonusInit: function () {
        var $qtyInput = $('.bonus-quantity input[type="text"]');

        $('body').on('click', '.bonus-quantity .plus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyIncrease($qtyInput);
        });

        $('body').on('click', '.bonus-quantity .minus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyDecrease($qtyInput);
        });
    }
});

module.exports = exportQuantityInput;
